<template>
    <v-layout row>
        <v-flex xs12>
            <v-sheet
                    class="d-flex"
            >
                <v-layout row>
                    <v-flex xs12 sm6>
                        <v-card flat>
                            <v-card-title primary-title>
                                <div class="headline">Job Details</div>
                            </v-card-title>
                            <loading v-if="loading" :loadingMessage="loadingMessage"></loading>
                            <template v-else>
                                <v-card-text>
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Job: {{job.inputParams.handler}} <span class="grey--text">#{{jobUID}}</span>
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Initiated: {{humanDate}} {{humanTime}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>User: {{job.user.email}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title>Status:</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-chip small :color="statusColour(job.status)" text-color="white">{{job.status}}</v-chip>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card-text>
                                <v-card-text v-if="exceptions">
                                    <v-list three-line dense subheader>
                                        <v-subheader>Exceptions</v-subheader>
                                        <template v-for="(exceptionKey, index) in Object.keys(job.exceptions)">
                                            <job-exception :key="exceptionKey" @click="" :exception="job.exceptions[exceptionKey]">
                                            </job-exception>
                                        </template>
                                    </v-list>
                                </v-card-text>
                                <v-card-text v-if="params">
                                    <v-expansion-panel>
                                        <v-expansion-panel-content>
                                            <div slot="header">Params</div>
                                            <v-list dense>
                                                <template v-for="(paramName, index) in Object.keys(params)">
                                                    <v-list-tile :key="paramName" @click="">
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>{{paramName}}: {{params[paramName]}}
                                                            </v-list-tile-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-divider
                                                            v-if="index + 1 < Object.keys(params).length"
                                                            :key="index"
                                                    ></v-divider>
                                                </template>
                                            </v-list>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-card-text>
                                <v-card-text v-if="jobType === 'exports'">
                                    <v-layout align-center class="mt-3">
                                        <v-flex xs12 text-xs-center>
                                            <v-btn
                                                    :loading="running"
                                                    :disabled="downloadDisabled"
                                                    color="primary"
                                                    class="white--text"
                                                    :href="downloadURL"
                                                    target="_blank"
                                                    large
                                            >
                                                Download
                                                <v-icon right dark>cloud_upload</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </template>
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex xs12 class="text-xs-center">
                                        <router-link :to="{name: 'dataops'}">Import/Export Dashboard</router-link>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-sheet>
        </v-flex>
    </v-layout>
</template>

<script>
  import JobException from '@/views/app/dataops/jobs/JobException'

  export default {
    name: 'dataops-JobView',
    components: {
      JobException
    },
    props: {
      jobUID: {
        type: String,
        required: true
      }
    },
    data: () => ({
      loading: true,
      loadingMessage: 'Loading job...',
      job: null,
      downloadLoading: false,
      downloadURL: null
    }),
    computed: {
      params () {
        return this.job.cleanParams
      },
      humanDate () {
        if (!this.job) {
          return 'n/a'
        }
        return new Date(this.job.initiated).toLocaleDateString()
      },
      humanTime () {
        if (!this.job) {
          return 'n/a'
        }
        return new Date(this.job.initiated).toTimeString()
      },
      completed () {
        return this.job && this.job.status === 'Completed'
      },
      aborted () {
        return this.job && this.job.status === 'Aborted'
      },
      exceptions () {
        return this.job && this.job.hasOwnProperty('exceptions')
      },
      downloadDisabled () {
        return this.downloadLoading || !this.downloadURL
      },
      running () {
        return !this.completed && !this.aborted
      },
      jobType () {
        return this.job.inputParams.handler.split('.')[0]
      }
    },
    created () {
      const self = this
      console.log('Loading Job')
      const jobRef = self.$firebaseClient.newRootRef('admin_ops').child('v0').child('jobs').child(self.jobUID)
      // We use on instead of once because the job status may update in real time
      jobRef.on('value', (snapshot) => {
        self.job = snapshot.val()
        self.loading = false
      })
    },
    methods: {
      getDownloadURL () {
        const self = this
        if (self.completed && self.params && self.params.targetBucket && self.params.targetPath && self.params.targetName) {
          self.downloadLoading = true
          const path = `gs://${self.params.targetBucket}/${self.params.targetPath}${self.params.targetName}`
          try {
            const exportDownloadRef = self.$firebaseClient.firebaseInstance.storage().refFromURL(path)
            exportDownloadRef.getDownloadURL().then((url) => {
              self.downloadURL = url
              self.downloadLoading = false
            })
          } catch (e) {
            console.log('Error creating download URL')
            self.downloadLoading = false
          }
        } else {
          console.log('Job not complete; can\'t generate download URL')
          self.downloadLoading = false
        }
      },
      statusColour (status) {
        switch (status) {
          case 'Completed':
            return 'success'
          case 'Aborted':
            return 'error'
          default:
            return 'primary'
        }
      },
      formatException(exceptionValue) {
        if (typeof exceptionValue === 'object') {
          return `${exceptionValue.message}: ${JSON.stringify(exceptionValue.data)}`
        } else {
          return exceptionValue
        }
      }
    },
    watch: {
      job (newVal) {
        // Trigger the generation of a download URL once the job is complete
        const self = this
        if (newVal.status === 'Completed') {
          self.getDownloadURL(newVal)
        }
      }
    }
  }
</script>

<style>
</style>
